import React from 'react';
import ReactTable from 'react-table';
import 'react-table/react-table.css';

import { ResultsStyles } from './styled-components';
import { RESULTS_PER_PAGE } from '../../util/constants';

// Make our noisy data appear slightly less noisy
const toTitleCase = str =>
  str == null
    ? str
    : str.replace(/\w\S*/g, function(txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });

const numberWithCommas = x => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const ResultTable = props => {
  const { data, onExport, onPageChange, onSortedChange, page, sorted } = props;
  const { hits, contributions } = data;
  const columns = [
    {
      id: 'name',
      Header: 'Donor',
      accessor: d => toTitleCase(d.donor.raw_name),
      sortable: false
    },
    {
      id: 'employerName',
      Header: 'Employer',
      accessor: d => toTitleCase(d.donor.employer.name),
      sortable: false
    },
    {
      id: 'occupation',
      Header: 'Occupation',
      accessor: d => toTitleCase(d.donor.occupation),
      sortable: false
    },
    {
      id: 'recipientName',
      Header: 'Recipient',
      accessor: d => toTitleCase(d.recipient.name),
      sortable: false
    },
    {
      id: 'contributionDate',
      Header: 'Date',
      accessor: 'date'
    },
    {
      id: 'donorStreet',
      Header: 'Street',
      accessor: d => toTitleCase(d.donor.address.street),
      sortable: false
    },
    {
      id: 'donorZip',
      Header: 'Zip',
      accessor: d => d.donor.address.zipcode,
      sortable: false
    },
    {
      id: 'donorCity',
      Header: 'City',
      accessor: d => toTitleCase(d.donor.address.city),
      sortable: false
    },
    {
      Header: 'Amount',
      accessor: 'amount',
      Cell: props => (
        <span className="number">
          ${numberWithCommas(props.value.toFixed(2))}
        </span>
      )
    }
  ];

  return (
    <ResultsStyles>
      <p>{hits} Results</p>
      {hits > 0 && <button onClick={onExport}>Export to CSV</button>}
      <ReactTable
        data={contributions}
        columns={columns}
        onPageChange={onPageChange}
        page={page}
        pages={Math.ceil(hits / RESULTS_PER_PAGE)}
        pageSize={RESULTS_PER_PAGE}
        showPageSizeOptions={false}
        onSortedChange={onSortedChange}
        sorted={sorted}
      />
    </ResultsStyles>
  );
};



// WEBPACK FOOTER //
// ./src/components/ResultTable/ResultTable.js